import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Button, Divider,
} from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';

const { platformName } = ThemeSelector.theme();

const LIST_STYLE = {
  paddingLeft: '1em',
};

const TypeButton = ({
  last,
  children,
  name,
  onClick,
  backgroundColor,
}) =>
  <Grid width={16}>
    <Grid.Row>
      <Grid.Column width={1} />
      <Grid.Column verticalAlign="middle" textAlign="center" width={6}>
        <Button
          style={{ backgroundColor, color: !onClick ? 'rgba(255,255,255,0.5)' : 'white' }}
          onClick={onClick}
          disabled={!onClick}
          size="large"
          fluid
        >{name}
        </Button>
      </Grid.Column>
      <Grid.Column width={1} />
      <Grid.Column width={8}>
        <h3> {name}</h3>
        <div style={{ color: 'gray' }}>
          {children}
        </div>
      </Grid.Column>
    </Grid.Row>
    {!last &&
      <Grid.Row>
        <Grid.Column width={16}>
          <Divider horizontal>Or</Divider>
        </Grid.Column>
      </Grid.Row>
    }
  </Grid>;

TypeButton.propTypes = {
  last: PropTypes.bool,
  children: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
};

TypeButton.defaultProps = {
  last: false,
  backgroundColor: null,
};

const STYLE = { paddingTop: 5, fontSize: '90%' };

const CampaignTypeButtons = ({
  onTypeSelected,
}) => (
  <div style={STYLE}>
    <TypeButton
      backgroundColor="#fc4085"
      name="Influencer Tracking Campaign"
      onClick={() => onTypeSelected('AUTOMATED')}
    >
      <ul style={LIST_STYLE}>
        <li>Set the campaign <i>#tag</i> or <i>@mention</i> you want to track</li>
        <li>Add influencers from your database</li>
        <li>{platformName} scans the influencer{'\''}s channels and automatically finds and tracks your posts and stories</li>
        <li>Or add your posts manually using the URL</li>
        <li>Request influencer authentication to track reach, impressions & stories data</li>
      </ul>
    </TypeButton>
    <TypeButton
      backgroundColor="#fdb02b"
      last
      name="Instagram Channel Report"
      onClick={() => onTypeSelected('ACR')}
    >
      <ul style={LIST_STYLE}>
        <li>Add a single Instagram Account (Creator, Business or Personal)</li>
        <li>Automatically track data from all posts added to this account</li>
        <li>Request account authorisation, via an influencer or brand</li>
        <li>If the account is authorised, {platformName} reports all impression, reach and stories data, from every post</li>
      </ul>
    </TypeButton>
  </div>
);

CampaignTypeButtons.propTypes = {
  onTypeSelected: PropTypes.func.isRequired,
};

export default CampaignTypeButtons;



/** WEBPACK FOOTER **
 ** ./src/components/new-add-campaign-modal/campaign-type-buttons.js
 **/